"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _has2 = _interopRequireDefault(require("lodash/has"));

var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _jsEvents = _interopRequireDefault(require("../../maps/jsEvents"));

var matchesId = function matchesId(id, pattern) {
  return id === pattern || pattern.endsWith('*') && id.startsWith(pattern.slice(0, pattern.length - 1));
};

var Track = function Track(_ref, context) {
  var children = _ref.children;

  switch (true) {
    case !children:
      throw new Error('Error creating Track element:  children is undefined, null, or falsey');

    case ! /*#__PURE__*/(0, _react.isValidElement)(children):
      throw new Error('Error creating Track element:  children of Track element is not a valid React element');

    case !children.props.id:
      throw new Error("'Error creating Track element:  children of Track element has no ID: ".concat(children.type));

    default:
      break;
  }

  var handlers = {};

  if (context && (0, _get2.default)(context, 'analyticsRules.elements')) {
    Object.keys(context.analyticsRules.elements).map(function (id) {
      if (matchesId(children.props.id, id)) {
        (0, _mapValues2.default)(context.analyticsRules.elements[id], function (analyticsValues, event) {
          // add handler with the event name from the analytics rule converted to the proper React event name
          // and assign the track function to it (will call AnalyticsEnhancedComponent.track with proper args)
          handlers[_jsEvents.default[event]] = function (e) {
            var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
            return context.analyticsTrack(e, analyticsValues, callback);
          };
        });
      }
    });
  } // compose with existing handlers:


  var composedHandlers = (0, _isEmpty2.default)(handlers) ? null : (0, _mapValues2.default)(handlers, function (handler, event) {
    return function (e) {
      var elementEvent = children.props[event];

      if ((0, _isFunction2.default)(elementEvent)) {
        elementEvent(e);
      } // Prevent default click behavior for navigation elements so that we don't navigate
      // away before events are tracked


      var isClickedNavigationElem = (0, _has2.default)(children, 'props.href') && event === 'onClick';

      if (isClickedNavigationElem && typeof e !== 'undefined') {
        e.stopPropagation(); // Allow default behavior in these cases, as the link will be opened in a new tab

        if (e.metaKey || e.ctrlKey) {
          isClickedNavigationElem = false;
        } else {
          e.preventDefault();
        }
      }

      handler(e, function () {
        // For navigation elements, provide navigation behavior in a post-track callback
        if (typeof window !== 'undefined' && isClickedNavigationElem) {
          if ((0, _get2.default)(children.props, 'target')) {
            window.open(children.props.href, (0, _get2.default)(children.props, 'target'));
          } else {
            window.location.href = children.props.href;
          }
        }
      });
    };
  });
  return /*#__PURE__*/(0, _react.cloneElement)(children, composedHandlers);
};

Track.contextTypes = {
  analyticsRules: _propTypes.default.object,
  analyticsTrack: _propTypes.default.func
};
var _default = Track;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/analytics/legacy/Track.js
// module id = 3135
// module chunks = 25